import React, { useEffect, useState,useContext } from 'react'
import UtilsBufer from '../Tools/UtilsBufer';
import MsgUtils from '../Tools/MsgUtils';
import UtilsListas from '../Tools/UtilsListas';
import { ReactSession } from "react-client-session";
import CircleLoader from "react-spinners/CircleLoader";
import ResponderMensaje from './ResponderMensaje';
import Modal from 'react-bootstrap/Modal';
const server = process.env.REACT_APP_SERVER;

function DetalleComunicado(props) {
  const { selectComu, regional, tipo } = props;
  const [respuestas, setRespuestas] = useState([]);
  const [vistas, setVistas] = useState([]);
  const [mostrar, setMostrar] = useState(true);
  const [mensage, setMensage] = useState("");
  const [actualizar, setActualizar] = useState(false);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState(0);
  const [modalResponder, setModalResponder] = useState(false);
  const eventoMostrar = () => {
    setTab(0);
    setMostrar(!mostrar);
  }
  async function send(tipo, mensage) {
    var idUsuario = ReactSession.get('idSession');
    var regional = ReactSession.get('regional');
    var empresaSucursal = ReactSession.get('empresaSucursal');
    var elegido = selectComu.ID_COMUNICADO;
    await fetch(`${server}/comunicados/lista/respuesta`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        vId: 0, idUsuario, regional, mensage, empresaSucursal, elegido, tipo,
      })
    })
      .then(res => res.json())
      .then(data => {
        if (data.ok) {
          setActualizar(actualizar + 1)
        } else {
          MsgUtils.msgError(data.error);
        }
      })
      .catch(err => console.log(err));
  }
  const enviarRespuesta = () => {
    setLoading(!loading);
    send('RES', mensage)
  }
  const descargarAdjunto = (e) => {
    var doc = selectComu.adjuntos.filter((item) => item.ID_ADJUNTO == e.target.id)
    window.open(`http://200.58.77.84:4370/?tipo=ADJ&adjid=${doc[0].ID_ADJUNTO}&ext=${doc[0].EXTENSION}`, "_blank");
  }
  const mostrarSeguimiento =(e)=>{
    console.log(e.target.id);
  }
  useEffect(() => {
    var idComunicado = selectComu.ID_COMUNICADO;
    fetch(`${server}/comunicados/lista/seguimiento`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        idComunicado, regional
      })
    })
      .then(res => res.json())
      .then(data => {
        if (data.ok) {
          var info = UtilsListas.getRespuestasSeparadas(data.ok);
          setRespuestas(info.respuestas);
          setVistas(info.vistas);
          setLoading(false);
        } else {
          MsgUtils.msgError(data.error);
        }
      })
      .catch(err => console.log(err));
  }, [actualizar])
  return (
    <div className='container-fluid'>
      <div className='container text-center'>
        <CircleLoader className="text-center mx-auto" color='#F95E10' loading={loading} size={200} />
      </div>
      {loading === false &&
        <div className='row'>
          <div className='container-fluid bg-dark bg-gradient'>
            <div className='row row-cols-2 g-2 tarjetaComunicado' >
              <div className='col-1 col-sm-2 col-md-4 col-lg-2 my-auto'>
                <div className='text-center text-white'>
                  {UtilsBufer.getFoto(selectComu.FOTO)}
                  <div className='nombre'><span className='d-none d-sm-inline'>{selectComu.COLABORADOR}</span></div>
                  <div className='cargo'><span className='d-none d-sm-inline'>{selectComu.CARGO}</span></div>
                </div>
              </div>
              <div className='col-auto col-sm-10 col-md-8 col-lg-10'>
                <div className='card'>
                  <div className='card-body p-0 m-1'>
                    {UtilsBufer.getText(selectComu.DETALLES)}
                  </div>
                  <div className='card-footer text-muted m-0 p-0'>
                    <div className='row row-cols-1 row-cols-md-2 g-0'>
                      <div className='col col-sm-5 text-dark my-auto'>
                        {UtilsListas.formatoFecha(selectComu.FECHA)} {UtilsListas.formatoHora(selectComu.FECHA)}
                      </div>
                      <div className='col col-sm-7 text-end'>
                        <div className="btn-group text-end" role="group" aria-label="Basic radio toggle button group">
                          <input type="radio"
                            className="btn-check"
                            name="btnradio"
                            id="btnradio1"
                            checked={tab === 0 ? true : false}
                            onChange={eventoMostrar} />
                          <label className="btn btn-secondary position-relative" >
                            <i className="fa-solid fa-comment-dots"></i> <span className='d-none d-xl-inline'>Respuestas</span>
                            <span className="position-absolute top-0 start-50 translate-middle badge rounded-pill bg-dark">
                              {respuestas.length}
                            </span>
                          </label>
                          <input type="radio" className="btn-check"
                            name="btnradio" id="btnradio2"
                            checked={tab === 1 ? true : false}
                            onChange={() => setTab(1)} />
                          <label className="btn btn-secondary position-relative">
                            <i className="fa-solid fa-paperclip"></i> <span className='d-none d-xl-inline'>Adjuntos</span>
                            <span className="position-absolute top-0 start-50 translate-middle badge rounded-pill bg-dark ">
                              {selectComu.adjuntos.length}
                            </span>
                          </label>
                          <input type="radio" className="btn-check"
                            name="btnradio" id="btnradio3"
                            checked={tab === 2 ? true : false}
                            onChange={() => setTab(2)} />
                          <label className="btn btn-secondary position-relative">
                            <i className="fa-solid fa-eye"></i> <span className='d-none d-xl-inline'>Leidos</span>
                            <span className="position-absolute top-0 start-50 translate-middle badge rounded-pill bg-dark">
                              {vistas.length}
                            </span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {tab === 0 &&
            <div className='container-fluid bg-dark bg-gradient'>
              <div className='overflow-auto targetRespuesta'>
                <table className="table table-striped table-bordered table-sm table-hover border-secondary">
                  <thead className='bg-secondary bg-gradient text-center fw-bold text-light m-0 p-0'>
                    <tr style={{ fontSize: '12px', margin: '0px', padding: '0px' }}>
                      <th scope="col">RESPUESTA</th>
                      <th scope="col">COLABORADOR</th>
                    </tr>
                  </thead>
                  <tbody>
                    {respuestas.map((item) => {
                      return (
                        <tr key={item.ID_SEGUIMIENTO} className="my-auto text-light">
                          <td className="col">{UtilsBufer.getText(item.DETALLES)} <a id={item.ID_SEGUIMIENTO} className={item.ID_ADJUNTO!==null?'btn text-light':'d-none'} onClick={mostrarSeguimiento}><i className="bi bi-eye-fill" id={item.ID_SEGUIMIENTO}></i></a></td>
                          <th className='col-6'>
                            <div className="card bg-transparent flex-row m-0 p-0" style={{ border: 'none' }}>
                              {UtilsBufer.getFotoCard(item.FOTO, 40)}
                              <div className='ps-2 my-auto d-none d-sm-inline'>
                                <div className="cargoHeader fw-bold" style={{ fontSize: '11px' }}>{item.COLABORADOR}</div>
                                <div className='cargoHeader ' style={{ fontSize: '11px' }}>{item.CARGO + ' - ' + item.SUCURSAL}</div>
                              </div>
                            </div>
                          </th>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>
              <div className={selectComu.TIPO == "R" ? 'col' : 'd-none'}>
                <div className='row row-cols-2 g-1 tarjetaComunicado' >
                  <div className='col-10'>
                    <div className={tipo === 'C' ? 'card bg-gradient' : 'd-none'}>
                      <div className='card-header p-0 m-1 fw-bold' style={{ fontSize: '11px' }}>
                        Respuesta de {ReactSession.get("nombre")}
                      </div>
                      <div className='card-body p-0 m-0 text-light'>
                        <div className="input-group mb-3">
                          <input type="text"
                            className="form-control"
                            placeholder="Escriba su respuesta ..."
                            aria-label="Recipient's username"
                            value={mensage}
                            onChange={(e) => setMensage(e.target.value)}
                            aria-describedby="basic-addon2" />
                          <button className="btn btn-secondary bg-gradient" id="basic-addon2" onClick={enviarRespuesta}><i className="fa-solid fa-paper-plane"></i> Enviar</button>
                        </div>
                      </div>
                    </div>
                    {tipo === 'M' &&
                      <a className='btn btn-secondary bg-gradient w-100'
                        onClick={() => setModalResponder(true)}>
                        <i className="fa-solid fa-square-pen"></i> Responder</a>
                    }
                  </div>
                  <div className='col-2 my-auto'>
                    <div className='text-center text-light'>
                      {UtilsBufer.getFoto(ReactSession.get("foto").data)}
                    </div>
                  </div>
                </div>
              </div>
            </div>}
          {tab === 1 &&
            <div className='container-fluid'>
              <ul className="list-group listaVistas" aria-labelledby="adjuntosMenu">
                {selectComu.adjuntos.map((item) => {
                  return (
                    <li id={item.ID_ADJUNTO} key={item.ID_COMUNICADO}>
                      <a id={item.ID_ADJUNTO} className="btn bg-secondary bg-gradient list-group-item text-dark"
                        onClick={descargarAdjunto}>
                        <i className="fa-solid fa-download"></i>
                        <span className='px-2 text-light'>
                          {'  ' + item.NOMBRE_VISIBLE + '.' + item.EXTENSION} {item.MINIATURA && UtilsBufer.getFoto(item.MINIATURA, 20)}
                        </span>
                      </a>
                    </li>
                  )
                })}
              </ul>
            </div>
          }
          {tab === 2 &&
            <div className='container-fluid bg-dark bg-gradient'>
              <div className='overflow-auto targetRespuesta'>
                <table className="table table-striped table-bordered table-sm table-hover border-secondary">
                  <thead className='bg-secondary bg-gradient text-center fw-bold text-light m-0 p-0'>
                    <tr style={{ fontSize: '12px', margin: '0px', padding: '0px' }}>
                      <th scope="col">RESPUESTA</th>
                      <th scope="col">COLABORADOR</th>
                    </tr>
                  </thead>
                  <tbody>
                    {vistas.map((item) => {
                      return (
                        <tr key={item.ID_SEGUIMIENTO} className="my-auto text-light">
                          <td className="col">Lo vio</td>
                          <th className='col-6'>
                            <div className="card bg-transparent flex-row m-0 p-0" style={{ border: 'none' }}>
                              {UtilsBufer.getFotoCard(item.FOTO, 40)}
                              <div className='ps-2 my-auto d-none d-sm-inline'>
                                <div className="cargoHeader fw-bold" style={{ fontSize: '11px' }}>{item.COLABORADOR}</div>
                                <div className='cargoHeader ' style={{ fontSize: '11px' }}>{item.CARGO + ' - ' + item.SUCURSAL}</div>
                              </div>
                            </div>
                          </th>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          }
        </div>}
      <Modal show={modalResponder} onHide={() => setModalResponder(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        contentClassName='modalNuevoC'>
        <Modal.Header closeButton closeVariant='black'>
          <Modal.Title bsPrefix='text-dark' id="contained-modal-title-vcenter">
            Responder
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {modalResponder && <ResponderMensaje selectComu={selectComu} setActualizar={setActualizar} actualizar={actualizar} setModalResponder={setModalResponder}/>}
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default DetalleComunicado
